export function useApiBlog() {
  const blogUrl = useRuntimeConfig().public?.BLOG_URL;

  async function getLatestPosts(count = 3): Promise<TBlogPost[] | void> {
    try {
      const posts = await $fetch<any[]>(`${ blogUrl }/wp-json/wp/v2/posts`, {
        query: {
          per_page: count,
          _embed: "wp:featuredmedia,wp:term",
          _fields: "id,date,link,title,excerpt,featured_media,_links,_embedded",
        },
      });

      return posts.map((post) => {
        const media = post._embedded?.["wp:featuredmedia"]?.[0];
        const term = post._embedded?.["wp:term"]
          ?.flat()
          .find((item: any) => item.taxonomy === "category");

        return {
          id: post.id,
          title: decodeEntities(post.title.rendered),
          desc: cleanExcerpt(post.excerpt.rendered),
          category: term ? term.name : undefined,
          path: post.link,
          date: post.date,
          img:
            media?.media_details?.sizes?.medium_large?.source_url ??
            media?.source_url ??
            undefined,
          imgAlt: media?.alt_text || decodeEntities(post.title.rendered),
        };
      });
    } catch (error) {
      console.error("Failed to load blog posts:", error);
      return;
    }
  };

  return { getLatestPosts };
};


function decodeEntities(text: string): string {
  return text
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/&nbsp;/g, " ")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, "&");
}

function cleanExcerpt(html: string): string {
  return decodeEntities(
    html
      .replace(/<a[^>]*class="read-more"[^>]*>.*?<\/a>/g, "")
      .replace(/<[^>]+>/g, ""),
  ).trim();
}


export type TBlogPost = {
  id: number;
  title: string;
  desc: string;
  category: string,
  path: string;
  date: string;
  img?: string;
  imgAlt?: string;
};